import React, { useRef } from 'react';
import ProductDescription from './product-description';
import ProductFeaturesAndTechnology from './product-features-and-technology';
import ProductSpecifications from './product-specifications';
import ProductVideo from './product-video';
import TabsAccordionContent from 'components/tabs-accordion-content';
import PropTypes from 'prop-types';
import cn from 'classnames';

const ProductDetails = ({
  className,
  description,
  specifications,
  video,
  featuresAndTechnology
}) => {
  const videoRef = useRef(null);
  const tabsItemsRef = useRef([]);

  const handleTabChange = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  const handleMobileAccordionPanelToggle = indexes => {
    if (!tabsItemsRef.current || !tabsItemsRef.current.length) return;

    const videoTabIndex = tabsItemsRef.current.findIndex(item => item.isVideo);

    if (videoTabIndex !== -1 && !indexes.includes(videoTabIndex)) {
      if (videoRef.current) {
        videoRef.current.pause();
      }
    }
  };

  const getTabsItems = () => {
    const items = [];

    if (description) {
      items.push({
        title: description.title,
        content: <ProductDescription content={description.content} />
      });
    }

    if (specifications) {
      items.push({
        title: specifications.title,
        content: (
          <ProductSpecifications
            metadataItems={specifications.metadataItems}
            measurementItems={specifications.measurementItems}
          />
        )
      });
    }

    if (video) {
      items.push({
        title: video.title,
        isVideo: true,
        content: <ProductVideo ref={videoRef} videoUrl={video.videoUrl} />
      });
    }

    if (featuresAndTechnology) {
      items.push({
        title: featuresAndTechnology.title,
        content: (
          <ProductFeaturesAndTechnology blocks={featuresAndTechnology.blocks} />
        )
      });
    }

    tabsItemsRef.current = items;

    return items;
  };

  return (
    <div className={cn('product-details', className)}>
      <TabsAccordionContent
        onTabChange={handleTabChange}
        onMobileAccordionPanelToggle={handleMobileAccordionPanelToggle}
        items={getTabsItems()}
      />
    </div>
  );
};

ProductDetails.propTypes = {
  className: PropTypes.string,
  description: PropTypes.exact(ProductDescription.propTypes),
  specifications: PropTypes.exact(ProductSpecifications.propTypes),
  video: PropTypes.exact(ProductVideo.propTypes),
  featuresAndTechnology: PropTypes.exact(ProductFeaturesAndTechnology.propTypes)
};

ProductDetails.propTypesMeta = {
  className: 'exclude'
};

export default ProductDetails;
